// extracted by mini-css-extract-plugin
export default {"overlay":"custom-popup_overlay__JGksa","popup":"custom-popup_popup__s4YjC","close":"custom-popup_close__yDQxR","content":"custom-popup_content__DbsK8"};